var map = {
	"./alitas.jpeg": "d033",
	"./alitas_de_pollo.jpg": "5303",
	"./almejas.jpg": "6975",
	"./aranitas.jpg": "df38",
	"./aranitas_2.jpeg": "3c88",
	"./camarones_al_ajillo.jpg": "e083",
	"./camarones_apanados.jpeg": "f1d9",
	"./ceviche_de_combinacion.jpg": "bb04",
	"./ceviche_de_concha_negra.jpg": "d5e5",
	"./ceviche_de_corvina.jpg": "4a45",
	"./ceviche_de_pulpo.jpg": "5af3",
	"./coctail_de_camaron.jpg": "ca0b",
	"./coctail_de_combinacion.jpg": "01a6",
	"./deditos_de_pescao.jpg": "0e5a",
	"./especial_a_lo_macho.jpg": "1b49",
	"./filete_al_ajillo.jpg": "92e5",
	"./filete_apanado.jpg": "459f",
	"./filete_con_almejas.jpg": "13dc",
	"./filete_con_camarones.jpg": "478b",
	"./filete_con_mixto.jpg": "e354",
	"./filete_frito.jpg": "3cfe",
	"./langosta_al_ajillo.jpg": "3100",
	"./langostinos_al_ajillo.jpg": "8092",
	"./logo.jpg": "541a",
	"./mixto_de_mariscos.jpg": "dcca",
	"./patacones_rellenos_de_camaraones.jpg": "4ded",
	"./patacones_rellenos_de_mixtos.jpg": "bf55",
	"./pescao_con_almeja.jpg": "278a",
	"./pescao_con_camarones.jpg": "80e1",
	"./pescao_con_mixto_de_mariscos.jpg": "796a",
	"./pescao_frito.jpg": "bde6",
	"./picada_mixta.jpg": "7de8",
	"./sopa_de_mariscos.jpeg": "8773",
	"./tender_de_pollo.jpg": "efa5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ecce";